import moment from 'moment'
import { BASE_DATE_FORMAT } from '@/common/definition'
import { API_URL_CORE, API_URL_GL, API_URL_EOC, API_URL_HR, API_URL_AP, API_URL_SY, API_URL_RADIUS } from '@/common/environment'

export function getUrl (module, route) {
  if (module === 'core') {
    return API_URL_CORE + route
  }

  if (module === 'gl') {
    return API_URL_GL + route
  }

  if (module === 'ap') {
    return API_URL_AP + route
  }

  if (module === 'eoc') {
    return API_URL_EOC + route
  }

  if (module === 'hr') {
    return API_URL_HR + route
  }

  if (module === 'sy') {
    return API_URL_SY + route
  }

  if (module === 'radius') {
    return API_URL_RADIUS + route
  }
}

export function isNewRecord (id) {
  if (id === undefined || id === null) {
    return false
  } else {
    let newID = 'J3SuSf1SKTYL0rDGjV37p4j1Ts_guBX721uT3JULVf9d8dv76yIthhod3Sp3n9McVF2XllD5j013_oPeQ2VJl0EfPXXYg4lj4y-8Aevmb8-xJk6Rs7yz10n-4NABDCl4PEfBAwe'
    return id.startsWith(newID)
  }
}

export function baseFormatDateDefault (date) {
  // return this.baseFormatDateTime(date, 'MM/DD/YYYY')
  if (date === null) {
    return ''
  }
  let dt = new Date(date)
  if (dt.getFullYear() === 1900 || dt.getFullYear() === 1 || dt.getFullYear() === 9999) {
    return ''
  }
  return moment(date).format(BASE_DATE_FORMAT)
}

export function baseDateFormatter (date) {
  return moment(date).format(BASE_DATE_FORMAT)
}

export function baseFormatDateTime (date, format) {
  if (date === null) {
    return ''
  }
  let dt = new Date(date)
  if (dt.getFullYear() === 1900 || dt.getFullYear() === 1 || dt.getFullYear() === 9999) {
    return ''
  }
  return moment(date).format(format)
}

export function baseFormatAmount (value) {
  return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
}

export function accessInformation (value) {
  let ret = ''
  let info = localStorage.getItem('accessInformation')

  if (info !== null) {
    info = info.split('|')

    for (let x = 0; x < info.length; x++) {
      let key = info[x]
      if (key.substring(0, 2) === value) {
        ret = key.substring(2)
        break
      }
    }
  }
  return ret
}

export function updateAccessInformation (oldValue, newValue) {
  let info = localStorage.getItem('accessInformation')
  if (info !== null) {
    info = info.replace(oldValue, newValue)
    localStorage.setItem('accessInformation', info)
  }
}

export function deleteLocalStorage () {
  delete localStorage.token
  delete localStorage.refreshToken
  delete localStorage.fname
  delete localStorage.lname
  delete localStorage.lastLogin
  delete localStorage.l0
  delete localStorage.l1
  delete localStorage.l2
  delete localStorage.l3
  delete localStorage.uname
  delete localStorage.apr
  delete localStorage.accessInformation
}
